import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';
import heroImg2 from '../../assets/hero-home-image2.png';
import PropertyAdvantage from '../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../components/ConversationSection/ConversationSection';
import proj1 from '../../assets/catogory/Apartments/img1.jpg';
import proj2 from '../../assets/catogory/Apartments/img2.jpg';
import proj3 from '../../assets/catogory/Residential_Plots/img1.jpg';
import proj4 from '../../assets/catogory/Apartments/img3.jpg';
import proj5 from '../../assets/catogory/Residential_Plots/img2.jpg';
import proj6 from '../../assets/catogory/Apartments/img1.jpg';

interface Project {
  id: number;
  name: string;
  location: string;
  type: 'APARTMENTS' | 'RESALE' | 'PLOTS';
  image: string;
}

const Projects = () => {
  const [selectedFilter, setSelectedFilter] = useState<string>('All');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const projects: Project[] = [
    {
      id: 1,
      name: 'Coral Residency',
      location: 'Vellanapatti, Coimbatore',
      type: 'APARTMENTS',
      image: proj1,
    },
    {
      id: 2,
      name: 'Crown City',
      location: 'Kovilpalayam, Coimbatore',
      type: 'APARTMENTS',
      image: proj2,
    },
    {
      id: 3,
      name: 'Crystal Gateway',
      location: 'Sulur, Coimbatore',
      type: 'PLOTS',
      image: proj3,
    },
    {
      id: 4,
      name: 'Diamond Avenue',
      location: 'Pattanam Pudur, Coimbatore',
      type: 'APARTMENTS',
      image: proj4,
    },
    {
      id: 5,
      name: 'Bougain Villea Apartment',
      location: 'Vilankurichi, Coimbatore',
      type: 'RESALE',
      image: proj5,
    },
    {
      id: 6,
      name: 'Lavender',
      location: 'Vilankurichi, Coimbatore',
      type: 'APARTMENTS',
      image: proj6,
    },
  ];

  const filteredProjects = selectedFilter === 'All'
    ? projects
    : projects.filter(property => property.type === selectedFilter);

  const handleFilterChange = (filter: string) => {
    setSelectedFilter(filter);
    setIsFilterOpen(false);
  };

  return (
    <div className="projects-page">
      <section className="projects-section">
        <div className="container">
          {/* HEADER */}
          <div className="projects-header">
            <div>
              <span className="tag">Property</span>
              <h2>Ongoing Projects</h2>
            </div>

            <div className="filter">
              <label>Filter by Types</label>
              <div className="custom-select">
                <div className="selected" onClick={() => setIsFilterOpen(!isFilterOpen)}>
                  {selectedFilter}
                  <span style={{ float: 'right', fontSize: '12px' }}>▼</span>
                </div>
                <ul className={`options ${isFilterOpen ? 'show' : ''}`}>
                  <li onClick={() => handleFilterChange('All')} className={selectedFilter === 'All' ? 'active' : ''}>All</li>
                  <li onClick={() => handleFilterChange('APARTMENTS')} className={selectedFilter === 'APARTMENTS' ? 'active' : ''}>APARTMENTS</li>
                  <li onClick={() => handleFilterChange('RESALE')} className={selectedFilter === 'RESALE' ? 'active' : ''}>RESALE</li>
                  <li onClick={() => handleFilterChange('PLOTS')} className={selectedFilter === 'PLOTS' ? 'active' : ''}>PLOTS</li>
                </ul>
              </div>
            </div>
          </div>

          {/* PROJECT GRID */}
          <div className="projects-grid">
            {filteredProjects.map((property) => (
              <div key={property.id} className="ongoing-property-card">
                <img src={property.image} alt={property.name} />
                <div className="card-body">
                  <h3>{property.name}</h3>
                  <p>{property.location}</p>
                  <Link to="/projects/details" className="btn">View Details</Link>
                </div>
              </div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="no-projects">
              <p>No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      <section className="projects-hero" style={{ backgroundImage: `url(${heroImg2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="hero-content">
          <h1>
            Lorem ipsum dolor sit.<br />
            <span>Our Projects</span>
          </h1>

          <Link to="#" className="hero-btn">
            Explore Projects <span>↗</span>
          </Link>
        </div>
      </section>
      <PropertyAdvantage />
      <ConversationSection />
    </div>
  );
};

export default Projects;
